import _ from 'lodash';
import Route from 'route-parser';
import URI from 'urijs';

import config from '../config';

// business logic:
// - we apply the disabled child's railcard ('DIC') to both the child and their accompanying adult
// - the disabled person's railcard ('DIS') rate is then applied to the adult's ticket,
//   rather than a discount on the child ticket
export function queryBuilder (fare, ticket) {
    let linkQuery = fare.getNRELinkQuery();
    if (ticket.railcard && ticket.railcard.code !== 'DIC') {
        _.set(linkQuery, 'railCard', ticket.railcard.code);
    }
    if (ticket.railcard && ticket.railcard.code === 'DIC' && ticket.adults > 0) {
        _.set(linkQuery, 'railCard', 'DIS');
    }
    return linkQuery;
}

export function getUrl (params, query) {
    let route = new Route('/:origin/:destination/:outwardDate/:price/:fareClass/:passenger');
    const path = route.reverse(params);
    const queryString = query ? URI.buildQuery(query, false, false) : '';
    return `${config.get('myTicketLinkNRE')}${path}?${queryString}`;
}
